export const defaultPasswordRules = (value) => {
  const regex = /^(?=.*[A-Z])(?=.*[\W_]).{8,}$/i
  return regex.test(value)
}
